export const replaceDevelopmentUrl = (url) => {
  return url?.startsWith("https://development.api.akrotonx.com")
    ? url.replace(
      "https://development.api.akrotonx.com",
      "https://akrotonx-prod.fra1.digitaloceanspaces.com"
    )
    : url;
};
